import { useEffect, useRef } from 'react';

import ResultCanvas from '../ResultCanvus';
import { useWheelData } from '@lib/hooks/useWheelData';

const WheelResultView = (props) => {
  const { setting, setWinner, setWinnerInfo, handleWheel, rosOptions, currentRosFeature } = useWheelData(s => ({
    setting: s.setting,
    setWinner: s.setWinner,
    setWinnerInfo: s.setWinnerInfo,
    handleWheel: s.handleWheel,
    rosOptions: s.rosOptions,
    currentRosFeature: s.currentRosFeature,
  }));
  const prevSettings = useRef({ setting, options: rosOptions });

  useEffect(() => {
    if (!props.showInstantCustomisationPopup) {
      prevSettings.current = { setting, options: rosOptions };
    }
  }, [props.showInstantCustomisationPopup, setting, rosOptions]);

  useEffect(() => {
    if (!props.showInstantCustomisationPopup) return;

    const prev = prevSettings.current.setting;
    if (
      setting?.wheelInteractionId === prev?.wheelInteractionId &&
            setting?.enableWheelOptions === prev?.enableWheelOptions &&
            setting?.wheelShowUser === prev?.wheelShowUser &&
            setting?.enableKeyword === prev?.enableKeyword &&
            setting?.wheelKeyword === prev?.wheelKeyword
    ) {
      return;
    }

    const wheelIdMap = JSON.parse(localStorage.getItem('wheelIdMap') || '{}');
    delete wheelIdMap[currentRosFeature?.id];
    localStorage.setItem('wheelIdMap', JSON.stringify(wheelIdMap));
    props.setCurrentRosResult([]);
    props.setIsResultView(false);

    setWinner(null);
    setWinnerInfo(null);
    handleWheel({ interactionId: null });
  }, [
    props.showInstantCustomisationPopup,
    setting?.wheelInteractionId,
    setting?.enableWheelOptions,
    setting?.wheelShowUser,
    setting?.enableKeyword,
    setting?.wheelKeyword
  ]);

  return <ResultCanvas {...props} />;
};

export default WheelResultView;
